<template>
  <div class="comment-card">
    <div class="comment-header">
      <div class="user-info">
        <div class="user-avatar">
          <img
            v-if="comment.user.avatar"
            :src="comment.user.avatar"
            :alt="userDisplayName"
            class="avatar-image"
          />
          <div v-else class="avatar-placeholder">
            {{ userInitials }}
          </div>
        </div>
        <div class="user-details">
          <div class="user-name">{{ userDisplayName }}</div>
          <div class="comment-meta">
            <div class="stars">
              <img
                v-for="star in fullStars"
                :key="'full-' + star"
                src="@/assets/images/starFill.svg"
                class="star-icon"
              />
              <img
                v-for="star in emptyStars"
                :key="'empty-' + star"
                src="@/assets/images/starOutline.svg"
                class="star-icon"
              />
            </div>
            <span class="comment-date">{{ comment.formattedDate }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="comment-content">
      <p class="comment-text">{{ comment.comment }}</p>
    </div>

    <div class="comment-footer">
      <div class="product-info">
        <img src="../assets/images/archiveBook.svg">

        <span class="product-label">{{ comment.marketplace.title }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MarketplaceCommentCard',
  props: {
    comment: {
      type: Object,
      required: true
    }
  },
  computed: {
    userDisplayName() {
      if (this.comment.user.name && this.comment.user.surname) {
        return `${this.comment.user.name} ${this.comment.user.surname}`;
      } else if (this.comment.user.name) {
        return this.comment.user.name;
      } else if (this.comment.user.surname) {
        return this.comment.user.surname;
      } else {
        return this.comment.user.email;
      }
    },
    userInitials() {
      if (this.comment.user.name && this.comment.user.surname) {
        return `${this.comment.user.name.charAt(0)}${this.comment.user.surname.charAt(0)}`.toUpperCase();
      } else if (this.comment.user.name) {
        return this.comment.user.name.substring(0, 2).toUpperCase();
      } else if (this.comment.user.surname) {
        return this.comment.user.surname.substring(0, 2).toUpperCase();
      } else {
        return this.comment.user.email.substring(0, 2).toUpperCase();
      }
    },
    fullStars() {
      return this.comment.rating;
    },
    emptyStars() {
      return 5 - this.comment.rating;
    }
  },
  methods: {
    viewProduct() {
      this.$router.push(`/marketplace/${this.comment.marketplace.uuid}`);
    },
    deleteComment() {
      this.$emit('delete-comment', this.comment);
    }
  }
}
</script>

<style scoped>
.comment-card {
  background: white;
  border-radius: 12px;
  padding: 20px;
  transition: all 0.2s ease;
}

.comment-card:hover {
  border-color: #d1d5db;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.comment-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.user-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
}

.avatar-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar-placeholder {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 600;
  font-size: 16px;
}

.user-details {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.user-name {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
}

.comment-meta {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #6b7280;
  margin-top: 2px;
}

.stars {
  display: flex;
  gap: 2px;
}

.star-icon {
  width: 14px;
  height: 14px;
}

.comment-date {
  font-size: 12px;
  color: #6b7280;
}

/* Content */
.comment-content {
  margin-bottom: 20px;

}

.comment-text {
  font-size: 14px;
  line-height: 1.6;
  color: #475467;
  margin: 0;
}

/* Footer */
.comment-footer {
  padding-top: 16px;
  display: flex;
  justify-content: start;
}

.product-info {
  display: flex;
  align-items: center;
  flex-direction: row;
  gap:4px;
}

.product-label {
  font-size: 12px;
  color: #101828;
  border-radius: 4px;
  display: inline-block;
}

/* Actions */
.comment-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  border: none;
  border-radius: 6px;
  background: transparent;
  cursor: pointer;
  transition: all 0.2s ease;
}

.action-btn:hover {
  background: #f3f4f6;
}

.action-btn.danger:hover {
  background: #fef2f2;
}

.action-icon {
  width: 16px;
  height: 16px;
}

/* Responsive */
@media (max-width: 768px) {
  .comment-card {
    padding: 16px;
  }

  .comment-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .comment-rating {
    align-self: flex-end;
  }

  .comment-footer {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  .comment-actions {
    align-self: stretch;
    justify-content: space-between;
  }

  .action-btn {
    flex: 1;
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .user-avatar {
    width: 40px;
    height: 40px;
  }

  .avatar-placeholder {
    font-size: 14px;
  }

  .user-name {
    font-size: 14px;
  }

  .comment-meta {
    font-size: 12px;
  }

  .star-icon {
    width: 14px;
    height: 14px;
  }
}
</style>
